module.exports = __webpack_public_path__ + "img/timer-waiting.470068b2.png";